import React from 'react';
import { ExportOutlined } from '@ant-design/icons';
import AdminPageHeader from '@/components/admin/AdminPageHeader';

const GUIDE_URL = '/user-guide.html';

const UserGuide: React.FC = () => {
  return (
    <div style={{ padding: 24 }}>
      <AdminPageHeader
        title="User Guide"
        description="Step-by-step guide for using the DasoonEgg platform."
        actions={[
          {
            icon: <ExportOutlined />,
            label: 'Open in New Tab',
            onClick: () => window.open(GUIDE_URL, '_blank', 'noopener,noreferrer'),
          },
        ]}
      />
      <div
        style={{
          background: '#fff',
          borderRadius: 8,
          overflow: 'hidden',
          boxShadow: '0 1px 2px rgba(0, 0, 0, 0.06)',
        }}
      >
        <iframe
          src={GUIDE_URL}
          title="DasoonEgg User Guide"
          style={{
            width: '100%',
            height: 'calc(100vh - 200px)',
            border: 'none',
            display: 'block',
          }}
        />
      </div>
    </div>
  );
};

export default UserGuide;
